module.exports = __webpack_public_path__ + "static/media/Question.53486c29.svg";